import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-229afa6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "xl:text-[44px] text-[40px] font-bold text-center pb-6"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-row justify-end items-end"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add Course", -1))
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center items-start mx-6" }
const _hoisted_5 = { class: "aspect-video w-full" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex flex-col space-y-2 px-3 py-5" }
const _hoisted_8 = { class: "text-[16px] xs:text-[21px] font-extrabold" }
const _hoisted_9 = { class: "pb-2 text-s xs:text-[16px] font-medium" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 2 }

import { ref, watch } from 'vue'
import { storeToRefs } from "pinia";
import { useCoursesStore } from "@/stores/coursesStore";
import { PlusIcon, PencilIcon } from "@heroicons/vue/24/outline";
import AddCourseDialog from "@/components/admin/AddCourseDialog.vue";
import { useUserStore } from "@/stores/userStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoursesSection',
  props: {
  showTitle: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const userStore = useUserStore();
const { isAdmin } = storeToRefs(userStore);

const coursesStore = useCoursesStore()
const { courses } = storeToRefs(coursesStore)

if (courses.value.length === 0) {
  coursesStore.fetchCourses();
}
watch(courses, () => {
  console.log(courses.value)
});

const props = __props

const isAddCourseDialogOpen = ref(false)
const editCourse = ref(null)
const openAddCourseDialog = () => {
  isAddCourseDialogOpen.value = true
}

const openEditCourseDialog = (course: any) => {
  editCourse.value = course
  isAddCourseDialogOpen.value = true
}

const closeAddCourseDialog = () => {
  isAddCourseDialogOpen.value = false
  editCourse.value = null
  coursesStore.fetchCourses(true);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([{
    'mt-6': !props.showTitle
      }, "flex flex-col space-y-8 w-full px-6 md:px-12 py-8 mb-52"])
  }, [
    (props.showTitle)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Courses"))
      : _createCommentVNode("", true),
    (_unref(isAdmin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: openAddCourseDialog,
            class: "flex flex-row items-center text-white justify-center bg-brand-secondary px-6 py-2 rounded-xl"
          }, [
            _createVNode(_unref(PlusIcon), { class: "h-4 w-4" }),
            _hoisted_3
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courses), (course) => {
        return (_openBlock(), _createElementBlock("div", {
          key: course.slug,
          class: "relative flex flex-col items-center justify-start h-full max-w-[360px] w-full"
        }, [
          _createVNode(_component_router_link, {
            to: '/course/' + course.slug + '/0',
            class: "hover:cursor-pointer mx-auto w-full flex flex-col space-y-2 bg-brand-card hover:bg-brand-card-hover text-center justify-start shadow-2xl rounded-xl h-full"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: course.image,
                  class: "w-full h-full object-cover aspect-video rounded-t-xl",
                  alt: "course"
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(course.title), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(course.description), 1)
              ])
            ]),
            _: 2
          }, 1032, ["to"]),
          (_unref(isAdmin))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: () => openEditCourseDialog(course),
                class: "absolute top-2 right-2 bg-brand-secondary text-white flex items-center p-2 rounded-full"
              }, [
                _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
              ], 8, _hoisted_10))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (isAddCourseDialogOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(AddCourseDialog, {
            "on-close": closeAddCourseDialog,
            course: editCourse.value
          }, null, 8, ["course"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})